import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PrimaryButton from '../PrimaryButton';
import CloseIcon from '../../../public/assets/images/theme-2/close-white.svg';
import { LoopTopSection, ClosePanelIcon } from '../LoopContentEditor/styles';
import { LoopFooterSection, BottomPanel } from '../HubContentEditor/styles';
import { PanelWrapper, HeaderSection, Header, PasswordWrapper, Description, PasswordInput } from './styles';

const PasswordPanel = ({ panel, loading = false, name, onContinue }) => {
  const [code, setCode] = useState('');

  const handleKeyPress = (event) => {
    switch (event.key) {
      case 'Enter':
        onContinue(code);
        break;
    }
  };

  return (
    <PanelWrapper>
      <LoopTopSection>
        <ClosePanelIcon disabled={loading} onClick={() => panel.hide()} src={CloseIcon} />
      </LoopTopSection>
      <HeaderSection>
        <Header>{name}</Header>
      </HeaderSection>
      <PasswordWrapper>
        <Description>{i18n.__('password_node_description')}</Description>
        <PasswordInput
          type="text"
          autoComplete="off"
          aria-label={i18n.__('password_node_placeholder')}
          placeholder={i18n.__('password_node_placeholder')}
          value={code}
          onChange={(event) => setCode(event.target.value)}
          onKeyUp={(ev) => handleKeyPress(ev)}
        />
      </PasswordWrapper>
      <LoopFooterSection>
        <BottomPanel align="flex-end">
          <PrimaryButton onClick={() => onContinue(code)} text={i18n.__('app_continue')} className="save-button" />
        </BottomPanel>
      </LoopFooterSection>
    </PanelWrapper>
  );
};

export default PasswordPanel;

PasswordPanel.propTypes = {
  panel: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  onContinue: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
};
